export const RESIDE_DOMAIN = "resideadmissions.com";
/**
 * Validates that a domain is in a whitelist.
 */
export const Validator = {
    name: "whitelist-domain-name",
    errorMessage: "User email domain does not belong to the organization approved domains list.",
    validate: (value, requirements) => {
        const userEmailDomain = value
            .substring(value.indexOf("@") + 1)
            .toLowerCase();
        const requiredDomainNames = requirements
            .split(",")
            .map(d => d.trim().toLowerCase());
        return requirements
            ? userEmailDomain === RESIDE_DOMAIN ||
                requiredDomainNames.includes(userEmailDomain)
            : true;
    },
};
